import React from "react";
import Header from "../../components/Header";
import { Row, Col, Typography } from "antd";
import Gear from "../../assets/gear.png";
import { Bullet } from "@ant-design/charts";

const Skill = ({ isBreakPosition }) => {
  const config = {
    data: [
      {
        title: "Javascript",
        measures: [98],
        targets: [100],
      },
      {
        title: "Node Js",
        measures: [87],
        targets: [100],
      },
      {
        title: "Flutter",
        measures: [45],
        targets: [100],
      },
      {
        title: "Java",
        measures: [72],
        targets: [100],
      },
      {
        title: "Photoshop",
        measures: [70],
        targets: [100],
      },
      {
        title: "Figma",
        measures: [76],
        targets: [100],
      },
      {
        title: "Php",
        measures: [88],
        targets: [100],
      },
    ],
    rangeMax: 100,
    color: ["#E3872D"],
    rangeColors: ["#E3872D"],
    markerColors: ["#E3872D"],
    measureColors: ["#E3872D"],
    forceFit: true,
    animation: true,
    label: {
      formatter: (text) => text + "%",
      style: {
        fontSize: 12,
        fontWeight: "bolder",
      },
    },
    xAxis: {
      visible: true,
      label: {
        style: {
          fontSize: 14,
          //   fontWeight: "bold",
        },
      },
    },
  };

  return (
    <div style={{ margin: "24px" }}>
      <Header
        width={isBreakPosition ? 12 : 8}
        title="Some About my Skill"
        desciption="More info about my skill"
        // withDesc
      />
      <img
        alt="Gear Background"
        style={{ right: 0, position: "absolute" }}
        src={Gear}
      />
      <Row>
        <Col span={24} style={{ marginTop: "8vmin" }}>
          <Typography.Paragraph
            style={{ width: isBreakPosition ? "100%" : "50%" }}
          >
            I have some skills that I've learned for a long time or that I've
            just learned. The bar below may not be appropriate because I don't
            always update this web
          </Typography.Paragraph>
        </Col>
        <Col span={24}>
          <Bullet {...config} style={{ position: "relative" }} />
        </Col>
      </Row>
    </div>
  );
};

export default Skill;
